<template>
  <div v-if="displayResponse">
    <SurveyQuestion
      :number="(index + 1)"
      :question="question"
      :activityId="activityId"
      :baseResponse="baseResponse"
      :selectedSlot="selectedSlot"
      @open-chart-modal="$emit('open-chart-modal',$event)"
      @slot_changed="selectedSlot = $event"
    >
    </SurveyQuestion>
    <div :id="'individual-response-container-' + response[0].id">

      <div class="row mx-5 fitb">
        <span class="mb-5" v-html="response[0].fitbResponse"></span>
      </div>

      <InlineEngagement
        ref="engagement"
        :type="morphType"
        :sentiment="true"
        :reply="true"
        :favourite="true"
        :destroy="true"
        :domain="domain"
        :probing="probing"
        :notepad="true"
        :response="response[0]"
        :activityId="activityId"
        :replyState="replyState"
        :hovering="(hovering && !hovering_replies) ? true : false"
        :baseResponse="baseResponse"
        @toggle_replies="toggle_replies()"
        @toggle_reply_input="toggle_reply_input(true)"
        @toggleNotepad="$emit('toggleNotepad',$event)"
      >
      </InlineEngagement>   
    </div>

    <Replies
      ref="replies"
      :activityId="activityId"
      :replies="response[0].replies"
      :repliable_type="morphType"
      :repliable_id="response[0].id"
      :replyState="replyState"
      :domain="domain"
      :probing="probing"
      :baseResponse="baseResponse"
      :baseMorph="morphType"
      :baseMorphId="response[0].id"
      :baseQuestionPosition="index"
      @cancel-reply-input="replyState.showReplyInput = false"
      @hovering-replies="hovering_replies = $event"
      @toggleNotepad="$emit('toggleNotepad',$event)"
    >
    </Replies>

    <div v-if="showSeparator" class="col-12 separator separator-solid separator-gray separator-border-1 mb-7 mt-10"></div>
  </div>
</template>

<script>
import SurveyQuestion from "../components/SurveyQuestion";
import InlineEngagement from "../InlineEngagement";

export default {
  name: "StreamSurveyFillInTheBlanks",

  props: {
    question: { type: Object, required: true },
    response: { type: Array, required: true },
    index: { type: Number, required: true },
    showSeparator: { type: Boolean, required: true },
    activityId: { type: Number, required: true },
    activityType: { type: String, required: true },
    baseResponse: { type: Number, required: true },
    probing: { type: Boolean,required: false, default:false },
    domain: { type: String, required: true, default: "admin" }
  },

  data() {
    return {
      selectedSlot: null,
      hovering: false,
      hovering_replies: false,
      replyState: {
        showReplies: ( this.probing ) ? true : false,
        showReplyInput: false
      }
    }
  },

  components: {
    SurveyQuestion,
    InlineEngagement
  },

  methods: {
    toggle_replies: function() {
      if (this.replyState.showReplies) {
        this.toggle_reply_input(false);
      } else {
        this.replyState.showReplies = true;
      }
    },
    toggle_reply_input: function(bool) {
      this.replyState.showReplies = bool;
      this.replyState.showReplyInput = bool;
    },
    applySelectedSlot: function(newSelectedSlot) {
      let responseSlots = document.getElementById(`individual-response-container-${this.response[0].id}`).getElementsByClassName("fitb-response");
      responseSlots.forEach(function(responseSlot) {
        if (newSelectedSlot == null || newSelectedSlot != null && responseSlot.id != newSelectedSlot) {
          responseSlot.classList.remove("selected");
        }
        if (responseSlot.id == newSelectedSlot) {
          responseSlot.classList.add("selected");
        }
      });
    }
  },

  watch: {
    selectedSlot: {
      handler(newSelectedSlot) {
        this.applySelectedSlot(newSelectedSlot);
      }
    }
  },

  computed: {
    displayResponse: function() {
      return (this.response.length == 1) ? true : false;
    },
    morphType: function() {
      let morphType = null;

      switch (this.activityType) {
        case 'diary':
          morphType = 'DiaryQuestionResponse';
          break;
        case 'survey':
          morphType = "SurveyQuestionResponse";
          break;
        case 'poll':
          morphType = "PollQuestionResponse";
          break;
      }

      return morphType;
    }
  }
}
</script>